import { Grid, Typography } from "@mui/material";
import ContentSection from "../../ContentSection";
import MxFormL3TextDateField from "@rf-l3/form/MxFormL3DatePickerField";
import MxFormL4DocumentFileProperty from "@/src-refactor/modules/shared/components/refactor/components/l4/form/MxFormL4DocumentFileProperty";
import MxTypography from "@rf-l1/MxTypography";
import useValidateExplicitField from "../../hooks/useValidateExplicitField";
import { useFormValidationsDocumentsMsgSlice } from "@rf/property/module/components/property-form/store/slices/form-validations-documents-msg/FormValidationsDocumentsMsgSlice";
import { CPropertyValidationDocumentKeys } from "@rf/property/module/components/property-form/util/schemas/validation-documents/validation-document.schema";
import useShowValidationInfo from "@rf/property/module/components/modal/useShowValidationInfo";
import { IFileData } from "@rf-l1/file/helpers/create-file-data";
import { CValidationDocumentKeys } from "../../../../../../../util/model/documents-types";

const FlowProject = () => {
  const {
    validationDocuments: { environment, building_license, land_movement }
  } = useFormValidationsDocumentsMsgSlice();
  return (
    <ContentSection
      title="Flujo de proyecto"
      tooltip="Flujo de proyecto"
      color="grey"
      alert={environment?.alert || land_movement?.alert || building_license?.alert}
    >
      <Grid container item xs={12} spacing={2}>
        <MedioAmbiente />
        <MovimientoTierra />
        <Licencia />
      </Grid>
    </ContentSection>
  );
};

export default FlowProject;

const MedioAmbiente = () => {
  const {
    validationDocuments: { environment }
  } = useFormValidationsDocumentsMsgSlice();
  const { validateField } = useValidateExplicitField();
  const { showNotification } = useShowValidationInfo();

  const handleOnClickOnExternalIndicators = (
    file: IFileData | null,
    ctx: any,
    itemCtx: any
  ) => {
    showNotification(itemCtx.msg, itemCtx.status);
  };

  return (
    <Grid container item xs={3} alignSelf={"flex-start"} rowGap={2}>
      <Grid container item xs={12}>
        <MxFormL4DocumentFileProperty
          withreacthookform={1}
          name={CPropertyValidationDocumentKeys.file_environment}
          label="Medio ambiente"
          maxSize={3}
          minSize={0}
          disabled={environment?.disabled!}
          typeKey={CValidationDocumentKeys.Environment}
        />
      </Grid>

      <Grid item xs={12}>
        <MxFormL3TextDateField
          withreacthookform={1}
          name={CPropertyValidationDocumentKeys.date_file_environment}
          label="Fecha de emisión"
          disabled={environment?.disabled}
        />
      </Grid>
    </Grid>
  );
};

const MovimientoTierra = () => {
  const {
    validationDocuments: { land_movement }
  } = useFormValidationsDocumentsMsgSlice();
  const { validateField } = useValidateExplicitField();
  const { showNotification } = useShowValidationInfo();

  const handleOnClickOnExternalIndicators = (
    file: IFileData | null,
    ctx: any,
    itemCtx: any
  ) => {
    showNotification(itemCtx.msg, itemCtx.status);
  };

  return (
    <Grid container item xs={3} alignSelf={"flex-start"} rowGap={2}>
      <Grid container item xs={12}>
        <MxFormL4DocumentFileProperty
          withreacthookform={1}
          name={CPropertyValidationDocumentKeys.file_evidence_earth_movement}
          label="Evidencia de movimiento de tierra"
          maxSize={3}
          minSize={0}
          disabled={land_movement?.disabled}
          typeKey={CValidationDocumentKeys.LandMovement}
        />
      </Grid>

      <Grid item xs={12}>
        <MxFormL3TextDateField
          withreacthookform={1}
          name={CPropertyValidationDocumentKeys.date_file_evidence_earth_movement}
          label="Fecha de toma de la foto"
          disabled={land_movement?.disabled}
        />
      </Grid>
    </Grid>
  );
};

const Licencia = () => {
  const {
    validationDocuments: { building_license }
  } = useFormValidationsDocumentsMsgSlice();

  const { validateField } = useValidateExplicitField();
  const { showNotification } = useShowValidationInfo();

  const handleOnClickOnExternalIndicators = (
    file: IFileData | null,
    ctx: any,
    itemCtx: any
  ) => {
    showNotification(itemCtx.msg, itemCtx.status);
  };

  return (
    <Grid container item xs={3} alignSelf={"flex-start"} rowGap={2}>
      <Grid container item xs={12}>
        <MxFormL4DocumentFileProperty
          withreacthookform={1}
          name={CPropertyValidationDocumentKeys.file_construction_license}
          label="Licencia de construcción"
          maxSize={3}
          minSize={0}
          disabled={building_license?.disabled!}
          typeKey={CValidationDocumentKeys.BuildingLicense}
        />
      </Grid>

      <Grid item xs={12}>
        <MxFormL3TextDateField
          withreacthookform={1}
          name={CPropertyValidationDocumentKeys.date_construction_license}
          label="Fecha de emisión"
          disabled={building_license?.disabled}
        />
      </Grid>
    </Grid>
  );
};
